import {ApiHostsEnum} from '../../index';
import createApiHostSelector from '../createApiHostSelector';


const selectS3host = createApiHostSelector(ApiHostsEnum.s3);

export default selectS3host;
